import { ResponseMessages } from "@sms/shared/message/message.interface";
import { eventChannel } from "redux-saga";
import { io, Socket } from "socket.io-client";

import { BASE_URL_WS } from "../utils/api-fetch";
import errorActions from "../error/error.actions";

import { connectedSocketMessage, handleUpdateMessage, reconnectedSocketMessage } from "./messages.actions";

export const createSocketEventsMessagesChannel: any = (): any =>
  eventChannel(emit => {
    socketMessages.on("connect", () => {
      emit(connectedSocketMessage());
    });
    socketMessages.on("reconnect", () => {
      emit(reconnectedSocketMessage());
    });
    socketMessages.on("createMessage", (data: ResponseMessages) => {
      emit(handleUpdateMessage(data));
    });

    socketMessages.on("updateMessage", (data: ResponseMessages) => {
      emit(handleUpdateMessage(data));
    });
    socketMessages.on("exception", (data: any) => {
      emit(errorActions.setSocketErrorAction(data));
    });

    return (): void => {
      socketMessages.off("connect");
      socketMessages.off("reconnect");
      socketMessages.off("recieveMessagesChat");
      socketMessages.off("recieveMessagesNextPage");
      socketMessages.off("createMessage");
      socketMessages.off("updateMessage");
    };
  });

export let socketMessages: Socket;

export function connectSocketMessage(): Socket {
  socketMessages = io(`${BASE_URL_WS}/message`, {
    transports: ["websocket"]
  });

  return socketMessages;
}
